<template>
  <div class="detail-page">
    <div class="detail-page__left">
      <CardLeftBlock :name="'Role Id'" :value="'#1'" />
    </div>
    <div class="detail-page__right">
      <CardRightBlock>

          <template slot="header">
            <div class="detail-page__head">
              <div class="detail-page__head-line">
                <div class="detail-page__header-col">
                  <router-link :to="$store.getters.GET_PATHS.settingsTranslationsGroup" class="detail-page__head-back">
                    <LinkBack
                            :value="'Back to Translations Group'"
                    />
                  </router-link>
                </div>
              </div>
            </div>
          </template>

        <template slot="body">
          <div class="registration-form__section">
            <div class="registration-form__row custom-row">
              <div class="registration-form__col custom-col custom-col--33">
                <div class="registration-form__input">
                  <DefaultInput
                          v-bind:class="{'ui-no-valid': validation.name}"
                          :error="validation.name"
                          :errorTxt="serverError ? validationTxt.name : 'This field is required'"
                          :label="'Name'"
                          :type="'text'"
                          v-model="name"
                  />
                </div>
              </div>
            </div>
          </div>


        </template>



        <template slot="footer">
          <div class="detail-page__footer">
            <div class="detail-page__footer-link">
              <router-link :to="$store.getters.GET_PATHS.settingsTranslationsGroup"
                           class="site-link site-link--alt"
              >
                Cancel
              </router-link>

            </div>
            <div class="detail-page__footer-btn">
              <MainButton
                      class="detail-page__footer-btn-i"
                      :value="'Change'"
                      @click.native="change"
                      v-bind:class="{'disabled-btn' : $store.getters.getTranslationsGroupBtn}"
              />
            </div>
          </div>
        </template>


      </CardRightBlock>

    </div>
  </div>
</template>

<script>
  import CardLeftBlock from '../../../../../coreComponents/CardLeftBlock/CardLeftBlock.vue'
  import CardRightBlock from '../../../../../coreComponents/CardRightBlock/CardRightBlock.vue'

  import DefaultInput from '../../../../../UI/inputs/DefaultInput/DefaultInput.vue'

  import LinkBack from '../../../../../UI/buttons/LinkBack/LinkBack.vue'
  import MainButton from '../../../../../UI/buttons/MainButton/MainButton.vue'

  import {validation} from "../../../../../../services/validation";



  var _ = require('lodash');

  export default {
    name: "TranslationsGroupCardPage",


    components: {
      CardLeftBlock,
      CardRightBlock,
      DefaultInput,
      LinkBack,
      MainButton,
    },



    data() {

      return {
        successForm: false,
        errorForm: false,
        serverError: false,

        translationsGroupId: '',
        name: '',


        validation: {
          name: false,
        },

        validationTxt: {
          name: false,
        },

      }
    },

    mounted() {

      this.$store.dispatch('fetchTranslationsGroupItem', this.$route.params.id).then(() => {
        let translationsGroupItem = this.$store.getters.getTranslationsGroupItem
        this.name = translationsGroupItem.name
      })

      this.translationsGroupId = this.$route.params.id;
    },

    methods: {

      changeSelect(items) {
        this.roles = items;
      },

      change() {
        let validationItems = {
          name: this.name,
        }

        let validationOptions = {
          name: {
            type: [
              'empty',
            ]
          },
        };

        let validate = validation(validationItems, validationOptions);
        this.validation = validate.validation;

        if (validate.isValidate) {
          this.serverError = false;

          let data = {
            'name': this.name,
          };

          this.$store.commit('changeTranslationsGroup');


          this.$store.dispatch('updateTranslationsGroups', {id: this.translationsGroupId, data: data}).then((response) => {

            if (_.has(response, 'data') && response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {

              this.$store.commit('successTranslationsGroup');

            } else if (response.response.data.status === this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE) {
              let errors = response.response.data.errors;

              this.serverError = true;

              errors.name ? (this.validation.name = true, this.validationTxt.name = errors.name[0]) : false;
            }

          });

        }

      },

    }

  }
</script>

<style lang="scss">

</style>
